import { ChangeEvent, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { PasswordInput, Button, Icon, InputField } from '@ets/design-system';

import styles from './PasswordRequiredElement.module.scss';

type PasswordRequiredElementProps = {
  password: string;
  setPassword: React.Dispatch<React.SetStateAction<string>>;
  errorState?: string;
};

const PasswordRequiredElement = ({
  password,
  setPassword,
  errorState,
}: PasswordRequiredElementProps) => {
  const intl = useIntl();

  const [value, setValue] = useState(password);

  const handleOnPasswordChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setValue(value);
  };

  const handleSubmitPassword = () => {
    setPassword(value);
  };

  return (
    <div className={styles.container}>
      <div className={styles.logoContainer}>
        <Icon icon="lock" size="20" testId="lock" color="primary" />
      </div>

      <span data-testid="public-link-protection-description">
        <div className={styles.title}>
          <FormattedMessage id="public.protected.protected1" />
        </div>
        <div className={styles.text}>
          <FormattedMessage id="public.protected.protected2" />
        </div>
      </span>
      <div style={{ marginBottom: '2rem' }}>
        <InputField
          label={intl.formatMessage({ id: 'PASSWORD' })}
          size="l"
          feedbackContent={
            errorState === 'wrong' ? intl.formatMessage({ id: 'settings.password.invalid' }) : ''
          }
          testId="public-link-password"
        >
          <PasswordInput
            size="l"
            placeholder={intl.formatMessage({ id: 'INSERT_YOUR_PASSWORD' })}
            value={value}
            onChange={handleOnPasswordChange}
            hasError={errorState === 'wrong'}
            width="37.5rem"
            testId="public-link-password"
          />
        </InputField>
        <Button
          size="m"
          variant="primary"
          style={{ marginTop: '1rem' }}
          disabled={!value}
          onClick={handleSubmitPassword}
          fullWidth
          testId="public-link-download"
        >
          <FormattedMessage id="public.unlockBtn" />
        </Button>
      </div>
    </div>
  );
};

export default PasswordRequiredElement;
